/*
 *   Module Loader
 *   Consumes an array of elements with .js-module classes to produce an array
 *   of module names to be loaded.
 *
 *   Markup must include data-module="['my-module-1', 'my-module-2']"
 *
 */

function camelize(text) {
  return text.replace(/-([a-z])/g, function (g) {
    return g[1].toUpperCase();
  });
}

function load(key, el) {
  const modules = {
    // smallGallery
    smallGallery: async () => {
      const { default: smallGallery } = await import(
        /* webpackChunkName: 'smallGallery' */
        './components/smallGallery'
      );
      new smallGallery(el);
      if (!__PROD__) console.log(`%c${key} loaded`, 'color: #000; background: yellow;');
    },
    // footer
    footer: async () => {
      const { default: footer } = await import(
        /* webpackChunkName: 'footer' */
        './components/footer'
      );
      new footer(el);
      if (!__PROD__) console.log(`%c${key} loaded`, 'color: #000; background: yellow;');
    },
    // hero
    hero: async () => {
      const { default: hero } = await import(
        /* webpackChunkName: 'hero' */
        './components/hero'
      );
      new hero(el);
      if (!__PROD__) console.log(`%c${key} loaded`, 'color: #000; background: yellow;');
    },
    // heroGallery
    heroGallery: async () => {
      const { default: heroGallery } = await import(
        /* webpackChunkName: 'heroGallery' */
        './components/heroGallery'
      );
      new heroGallery(el);
      if (!__PROD__) console.log(`%c${key} loaded`, 'color: #000; background: yellow;');
    },
    // membership
    membership: async () => {
      const { default: membership } = await import(
        /* webpackChunkName: 'membership' */
        './components/membership'
      );
      new membership(el);
      if (!__PROD__) console.log(`%c${key} loaded`, 'color: #000; background: yellow;');
    },
    // navigation
    navigation: async () => {
      const { default: navigation } = await import(
        /* webpackChunkName: 'navigation' */
        './components/navigation'
      );
      new navigation(el);
      if (!__PROD__) console.log(`%c${key} loaded`, 'color: #000; background: yellow;');
    },
    // RTE Table
    rteTable: async () => {
      const { default: rteTable } = await import(
        /* webpackChunkName: 'rteTable' */
        '../templates/02-components/subcomponents/_rich-text-table/mando-ui.rte-table'
      );
      new rteTable(el);
      if (!__PROD__) console.log(`%c${key} loaded`, 'color: #000; background: yellow;');
    },
    // twitterFeed
    twitterFeed: async () => {
      const { default: twitterFeed } = await import(
        /* webpackChunkName: 'twitterFeed' */
        './components/twitterFeed'
      );
      new twitterFeed(el);
      if (!__PROD__) console.log(`%c${key} loaded`, 'color: #000; background: yellow;');
    },
    // videoGallery
    videoGallery: async () => {
      const { default: videoGallery } = await import(
        /* webpackChunkName: 'videoGallery' */
        './components/videoGallery'
      );
      new videoGallery(el);
      if (!__PROD__) console.log(`%c${key} loaded`, 'color: #000; background: yellow;');
    },
  };
  try {
    // return Promise
    return modules[key]();
  } catch (e) {
    console.error(`Module ${key} not found.`);
  }
}

function init(modules) {
  if (!modules) return;
  const moduleList = [];
  modules.forEach((element) => {
    try {
      const moduleNames = element.dataset.module;
      if (moduleNames) {
        const moduleArray = JSON.parse(moduleNames.replace(/'/g, '"'));
        moduleArray.forEach((item) => {
          const module = camelize(item);
          if (moduleList.indexOf(module) === -1) {
            moduleList.push({
              name: module,
              element: element,
            });
          }
        });
      }
    } catch (e) {
      console.error('JS name format incorrect in data attribute:');
    }
  });

  moduleList.forEach((module) => load(module.name, module.element));
}

export default init;
